var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }